/**
 * @file: markRequestViolation.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { requestViolationsOf } from '@euler/lib/request/requestErrorDetails';
import type { FormFieldState, FormState } from './controller';
import type { FormData } from './types';

/**
 * Marks the input a request error names first, with the server's sentence —
 * which is about that very input (请填写车牌号). `formFieldOf` maps a request
 * path the form does not use as a key to the input that holds it. Returns
 * whether an input of this form was marked; the caller still shows the
 * sentence for an input the form does not have.
 */
export function markRequestViolation<T extends FormData>(
  form: FormState<T>,
  error: unknown,
  formFieldOf?: (field: string) => string | undefined,
): boolean {
  const [first] = requestViolationsOf(error);
  if (first == null || !(error instanceof Error)) return false;
  const key = formFieldOf?.(first.field) ?? first.field;
  if (!Object.prototype.hasOwnProperty.call(form, key)) return false;
  const field = (
    form as unknown as Record<string, FormFieldState<unknown> | undefined>
  )[key];
  if (field == null) return false;
  field.setError(error.message);
  return true;
}
